import React from "react";

export default function CommunicationsCaseStudies({ items }) {
  return (
    <div className="mx-auto mt-8 w-full max-w-[480px]">
      {items.map((project, index) => (
        <article data-reveal key={project.id} className="grid grid-cols-2 items-stretch gap-0">
          <div className={`overflow-hidden ${index % 2 ? "order-2" : "order-1"}`}>
            {project.image ? (
              <img
                src={project.image}
                alt={project.imageAlt}
                loading="lazy"
                className={`aspect-square w-full object-cover ${project.imageClassName || ""}`}
              />
            ) : (
              <div className="flex aspect-square w-full items-center justify-center border border-[#D8D2C4] bg-[#FCFAF4] text-xs tracking-wide text-[#8A8173]">
                Project image
              </div>
            )}
            {project.url && (
              <a
                href={project.url}
                target="_blank"
                rel="noopener noreferrer"
                className="minimal-link mt-4 inline-flex pb-1 text-xs tracking-wide"
              >
                {project.linkLabel || "View project"} <span aria-hidden="true">↗</span>
                <span className="sr-only">: {project.title}</span>
              </a>
            )}
          </div>
          <div className={`flex min-w-0 flex-col justify-center p-4 text-left sm:p-6 ${index % 2 ? "order-1" : "order-2"}`}>
            <h4 className="font-lora-bold text-sm leading-5 sm:text-base sm:leading-6">{project.title}</h4>
            {project.description && <p className="mt-3 text-xs leading-5 sm:text-sm sm:leading-6">{project.description}</p>}
          </div>
        </article>
      ))}
    </div>
  );
}
